import styled from 'styled-components';

export const InputLabel = styled.div`
  color: #3C3B3B;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Poppins-Bold;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  margin-top: 40px;
  margin-bottom: 5px;
`;

export const InputIdentifier = styled.input`
  font-family: Poppins-Regular;
  font-size: 14px;
  line-height: 21px;
  color: #2A0006;
  background-color: #fff;
  border-radius: 2px;
  border: 1px solid #DEDDDC;
  box-sizing: border-box;
  padding: 10px;
  width: 100%;

  ::placeholder {
    color: #BFBEBE;
  }

  &:focus {
    outline: none;
    border-color: #D40020;
    box-shadow: 0 0 0 2px rgba(212, 0, 32, 0.15);
  }
`;

export const ConfirmButton = styled.button`
  border-radius: 99px;
  background: var(--Primary-Info-Red-Original, #D40020);
  padding: 16px 10px;
  min-height: 56px;
  width: auto;
  cursor: pointer;
  color: #fff;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
  min-width: 200px;
  width: 100%;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;